module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card buttonsDiv"
  }, [_c('el-checkbox', {
    staticClass: "correction-check",
    on: {
      "change": function($event) {
        return _vm.getTableData()
      }
    },
    model: {
      value: (_vm.correction),
      callback: function($$v) {
        _vm.correction = $$v
      },
      expression: "correction"
    }
  }, [_vm._v("Bez korekt\n                ")]), _vm._v(" "), _vm._l((_vm.months.length), function(monthNumber) {
    return _c('el-button', {
      class: {
        'el-button--primary': _vm.month == monthNumber - 1
      },
      on: {
        "click": function($event) {
          return _vm.changeDatePeriod(monthNumber - 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.months[monthNumber - 1]) + "\n                ")])
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd",
      "change": "loading"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('json-excel', {
    staticClass: "el-button el-button--default",
    attrs: {
      "data": _vm.jsonData,
      "fields1": _vm.json_fields1,
      "fields2": _vm.json_fields2,
      "name": ("raport_pitformat_" + _vm.lic + "_" + _vm.excelDate + ".xls")
    },
    on: {
      "onPrepareExportData": _vm.prepareExportData
    }
  }, [_vm._v("Eksport do excela\n\n\n                ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExeOnline, 'fills'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExeOnline, 'fills'),
      "dayDisplay": true,
      "dataType": "fills",
      "title": "Liczba wypełnień w podziale na deklaracje",
      "subTitle": "wersja instalacyjna + wersja online",
      "data": _vm.tableDataExeOnline
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExeOnline, 'amounts'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExeOnline, 'amounts'),
      "dayDisplay": true,
      "dataType": "amounts",
      "title": "Kwoty 1% w podziale na deklaracje",
      "subTitle": "wersja instalacyjna + wersja online",
      "data": _vm.tableDataExeOnline
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 "
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExe, 'amounts'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExe, 'amounts'),
      "id": "test2",
      "dayDisplay": true,
      "dataType": "amounts",
      "title": "Kwoty 1% w podziale na deklaracje",
      "subTitle": "wersja instalacyjna",
      "data": _vm.tableDataExe
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataOnline, 'amounts'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataOnline, 'amounts'),
      "id": "test",
      "dayDisplay": true,
      "dataType": "amounts",
      "title": "Kwoty 1% w podziale na deklaracje",
      "subTitle": "wersja online",
      "data": _vm.tableDataOnline
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 "
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(_vm.tableDataExe, 'fills'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataExe, 'fills'),
      "dayDisplay": true,
      "dataType": "fills",
      "title": "Liczba wypełnień w podziale na deklaracje",
      "subTitle": "wersja instalacyjna",
      "data": _vm.tableDataExe
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 "
  }, [_c('div', {
    staticClass: "card"
  }, [_c('declarations-table', {
    attrs: {
      "sum": _vm.calculateSum(this.tableDataOnline, 'fills'),
      "sumRows": _vm.calculateRowSums(_vm.tableDataOnline, 'fills'),
      "dayDisplay": true,
      "dataType": "fills",
      "title": "Liczba wypełnień w podziale na deklaracje",
      "subTitle": "wersja online",
      "data": _vm.tableDataOnline
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12c6fc64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/DeclarationsStats.vue
// module id = 436
// module chunks = 1